import { ProjectEnvironment } from 'types/apis/pilotInterfaces';

/**
 * Utility functions for handling environment data conversion between old and new formats
 */

export interface EnvironmentData {
  environment?: ProjectEnvironment;
  projectEnvironments?: ProjectEnvironment[];
}

/**
 * Get environment data from a project
 */
export const getEnvironmentData = (project: any): ProjectEnvironment[] => {
  if (project.environment) {
    // Single environment object
    return [project.environment];
  }
  return [];
};

/**
 * Get the first environment from a project
 */
export const getFirstEnvironment = (project: any): ProjectEnvironment | null => {
  const environments = getEnvironmentData(project);
  return environments.length > 0 ? environments[0] : null;
};

/**
 * Check if a project has an existing environment
 */
export const hasExistingEnvironment = (project: any): boolean => {
  return !!(project.environment_id && project.environment_id.trim() !== '');
};

/**
 * Find environment by process_id
 */
export const findEnvironmentByProcessId = (project: any, processId: string): ProjectEnvironment | null => {
  const environments = getEnvironmentData(project);
  return environments.find(env => env.process_id === processId) || null;
};

/**
 * Convert single environment to array format for form compatibility
 */
export const environmentToArray = (environment: ProjectEnvironment): ProjectEnvironment[] => {
  return [environment];
};

/**
 * Convert array environment to single object format
 */
export const arrayToEnvironment = (environments: ProjectEnvironment[]): ProjectEnvironment | null => {
  return environments.length > 0 ? environments[0] : null;
}; 